export const countryCodesByTimezone: Record<string, string> = {
  'Europe/Andorra': 'AD',
  'Asia/Dubai': 'AE',
  'Asia/Kabul': 'AF',
  'Europe/Tirane': 'AL',
  'Asia/Yerevan': 'AM',
  'Antarctica/Casey': 'AQ',
  'Antarctica/Davis': 'AQ',
  'Antarctica/Mawson': 'AQ',
  'Antarctica/Palmer': 'AQ',
  'Antarctica/Rothera': 'AQ',
  'Antarctica/Troll': 'AQ',
  'Antarctica/Vostok': 'AQ',
  'America/Argentina/Buenos_Aires': 'AR',
  'America/Argentina/Cordoba': 'AR',
  'America/Argentina/Salta': 'AR',
  'America/Argentina/Jujuy': 'AR',
  'America/Argentina/Tucuman': 'AR',
  'America/Argentina/Catamarca': 'AR',
  'America/Argentina/La_Rioja': 'AR',
  'America/Argentina/San_Juan': 'AR',
  'America/Argentina/Mendoza': 'AR',
  'America/Argentina/San_Luis': 'AR',
  'America/Argentina/Rio_Gallegos': 'AR',
  'America/Argentina/Ushuaia': 'AR',
  'Pacific/Pago_Pago': 'AS',
  'Europe/Vienna': 'AT',
  'Australia/Lord_Howe': 'AU',
  'Antarctica/Macquarie': 'AU',
  'Australia/Hobart': 'AU',
  'Australia/Melbourne': 'AU',
  'Australia/Sydney': 'AU',
  'Australia/Broken_Hill': 'AU',
  'Australia/Brisbane': 'AU',
  'Australia/Lindeman': 'AU',
  'Australia/Adelaide': 'AU',
  'Australia/Darwin': 'AU',
  'Australia/Perth': 'AU',
  'Australia/Eucla': 'AU',
  'Asia/Baku': 'AZ',
  'America/Barbados': 'BB',
  'Asia/Dhaka': 'BD',
  'Europe/Brussels': 'NL',
  'Europe/Sofia': 'BG',
  'Atlantic/Bermuda': 'BM',
  'America/La_Paz': 'BO',
  'America/Noronha': 'BR',
  'America/Belem': 'BR',
  'America/Fortaleza': 'BR',
  'America/Recife': 'BR',
  'America/Araguaina': 'BR',
  'America/Maceio': 'BR',
  'America/Bahia': 'BR',
  'America/Sao_Paulo': 'BR',
  'America/Campo_Grande': 'BR',
  'America/Cuiaba': 'BR',
  'America/Santarem': 'BR',
  'America/Porto_Velho': 'BR',
  'America/Boa_Vista': 'BR',
  'America/Manaus': 'BR',
  'America/Eirunepe': 'BR',
  'America/Rio_Branco': 'BR',
  'Asia/Thimphu': 'BT',
  'Europe/Minsk': 'BY',
  'America/Belize': 'BZ',
  'America/St_Johns': 'CA',
  'America/Halifax': 'CA',
  'America/Glace_Bay': 'CA',
  'America/Moncton': 'CA',
  'America/Goose_Bay': 'CA',
  'America/Toronto': 'CA',
  'America/Iqaluit': 'CA',
  'America/Winnipeg': 'CA',
  'America/Resolute': 'CA',
  'America/Rankin_Inlet': 'CA',
  'America/Regina': 'CA',
  'America/Swift_Current': 'CA',
  'America/Edmonton': 'CA',
  'America/Cambridge_Bay': 'CA',
  'America/Inuvik': 'CA',
  'America/Dawson_Creek': 'CA',
  'America/Fort_Nelson': 'CA',
  'America/Whitehorse': 'CA',
  'America/Dawson': 'CA',
  'America/Vancouver': 'CA',
  'Europe/Zurich': 'DE',
  'Africa/Abidjan': 'GH',
  'Pacific/Rarotonga': 'CK',
  'America/Santiago': 'CL',
  'America/Coyhaique': 'CL',
  'America/Punta_Arenas': 'CL',
  'Pacific/Easter': 'CL',
  'Asia/Shanghai': 'CN',
  'Asia/Urumqi': 'CN',
  'America/Bogota': 'CO',
  'America/Costa_Rica': 'CR',
  'America/Havana': 'CU',
  'Atlantic/Cape_Verde': 'CV',
  'Asia/Nicosia': 'CY',
  'Asia/Famagusta': 'CY',
  'Europe/Prague': 'CZ',
  'Europe/Berlin': 'DE',
  'America/Santo_Domingo': 'DO',
  'Africa/Algiers': 'DZ',
  'America/Guayaquil': 'EC',
  'Pacific/Galapagos': 'EC',
  'Europe/Tallinn': 'EE',
  'Africa/Cairo': 'EG',
  'Africa/El_Aaiun': 'EH',
  'Europe/Madrid': 'ES',
  'Africa/Ceuta': 'ES',
  'Atlantic/Canary': 'ES',
  'Europe/Helsinki': 'FI',
  'Pacific/Fiji': 'FJ',
  'Atlantic/Stanley': 'FK',
  'Pacific/Kosrae': 'FM',
  'Atlantic/Faroe': 'FO',
  'Europe/Paris': 'FR',
  'Europe/London': 'GB',
  'Asia/Tbilisi': 'GE',
  'America/Cayenne': 'GF',
  'Europe/Gibraltar': 'GI',
  'America/Nuuk': 'GL',
  'America/Danmarkshavn': 'GL',
  'America/Scoresbysund': 'GL',
  'America/Thule': 'GL',
  'Europe/Athens': 'GR',
  'Atlantic/South_Georgia': 'GS',
  'America/Guatemala': 'GT',
  'Pacific/Guam': 'GU',
  'Africa/Bissau': 'GW',
  'America/Guyana': 'GY',
  'Asia/Hong_Kong': 'HK',
  'America/Tegucigalpa': 'HN',
  'America/Port-au-Prince': 'HT',
  'Europe/Budapest': 'HU',
  'Asia/Jakarta': 'ID',
  'Asia/Pontianak': 'ID',
  'Asia/Makassar': 'ID',
  'Asia/Jayapura': 'ID',
  'Europe/Dublin': 'IE',
  'Asia/Jerusalem': 'IL',
  'Asia/Kolkata': 'IN',
  'Indian/Chagos': 'IO',
  'Asia/Baghdad': 'IQ',
  'Asia/Tehran': 'IR',
  'Europe/Rome': 'IT',
  'America/Jamaica': 'JM',
  'Asia/Amman': 'JO',
  'Asia/Tokyo': 'JP',
  'Africa/Nairobi': 'ET',
  'Asia/Bishkek': 'KG',
  'Pacific/Tarawa': 'KI',
  'Pacific/Kanton': 'KI',
  'Pacific/Kiritimati': 'KI',
  'Asia/Pyongyang': 'KP',
  'Asia/Seoul': 'KR',
  'Asia/Almaty': 'KZ',
  'Asia/Qyzylorda': 'KZ',
  'Asia/Qostanay': 'KZ',
  'Asia/Aqtobe': 'KZ',
  'Asia/Aqtau': 'KZ',
  'Asia/Atyrau': 'KZ',
  'Asia/Oral': 'KZ',
  'Asia/Beirut': 'LB',
  'Asia/Colombo': 'LK',
  'Africa/Monrovia': 'LR',
  'Europe/Vilnius': 'LT',
  'Europe/Riga': 'LV',
  'Africa/Tripoli': 'LY',
  'Africa/Casablanca': 'MA',
  'Europe/Chisinau': 'MD',
  'Pacific/Kwajalein': 'MH',
  'Asia/Yangon': 'MM',
  'Asia/Ulaanbaatar': 'MN',
  'Asia/Hovd': 'MN',
  'Asia/Macau': 'MO',
  'America/Martinique': 'MQ',
  'Europe/Malta': 'MT',
  'Indian/Mauritius': 'MU',
  'Indian/Maldives': 'MV',
  'America/Mexico_City': 'MX',
  'America/Cancun': 'MX',
  'America/Merida': 'MX',
  'America/Monterrey': 'MX',
  'America/Matamoros': 'MX',
  'America/Chihuahua': 'MX',
  'America/Ciudad_Juarez': 'MX',
  'America/Ojinaga': 'MX',
  'America/Mazatlan': 'MX',
  'America/Bahia_Banderas': 'MX',
  'America/Hermosillo': 'MX',
  'America/Tijuana': 'MX',
  'Asia/Kuching': 'MY',
  'Africa/Maputo': 'CD',
  'Africa/Windhoek': 'NA',
  'Pacific/Noumea': 'NC',
  'Pacific/Norfolk': 'NF',
  'Africa/Lagos': 'NG',
  'America/Managua': 'NI',
  'Asia/Kathmandu': 'NP',
  'Pacific/Nauru': 'NR',
  'Pacific/Niue': 'NU',
  'Pacific/Auckland': 'NZ',
  'Pacific/Chatham': 'NZ',
  'America/Panama': 'CA',
  'America/Lima': 'PE',
  'Pacific/Tahiti': 'PF',
  'Pacific/Marquesas': 'PF',
  'Pacific/Gambier': 'PF',
  'Pacific/Port_Moresby': 'PG',
  'Pacific/Bougainville': 'PG',
  'Asia/Manila': 'PH',
  'Asia/Karachi': 'PK',
  'Europe/Warsaw': 'PL',
  'America/Miquelon': 'PM',
  'Pacific/Pitcairn': 'PN',
  'America/Puerto_Rico': 'CA',
  'Asia/Gaza': 'PS',
  'Asia/Hebron': 'PS',
  'Europe/Lisbon': 'PT',
  'Atlantic/Madeira': 'PT',
  'Atlantic/Azores': 'PT',
  'Pacific/Palau': 'PW',
  'America/Asuncion': 'PY',
  'Asia/Qatar': 'QA',
  'Europe/Bucharest': 'RO',
  'Europe/Belgrade': 'RS',
  'Europe/Kaliningrad': 'RU',
  'Europe/Moscow': 'RU',
  'Europe/Simferopol': 'RU',
  'Europe/Kirov': 'RU',
  'Europe/Volgograd': 'RU',
  'Europe/Astrakhan': 'RU',
  'Europe/Saratov': 'RU',
  'Europe/Ulyanovsk': 'RU',
  'Europe/Samara': 'RU',
  'Asia/Yekaterinburg': 'RU',
  'Asia/Omsk': 'RU',
  'Asia/Novosibirsk': 'RU',
  'Asia/Barnaul': 'RU',
  'Asia/Tomsk': 'RU',
  'Asia/Novokuznetsk': 'RU',
  'Asia/Krasnoyarsk': 'RU',
  'Asia/Irkutsk': 'RU',
  'Asia/Chita': 'RU',
  'Asia/Yakutsk': 'RU',
  'Asia/Khandyga': 'RU',
  'Asia/Vladivostok': 'RU',
  'Asia/Ust-Nera': 'RU',
  'Asia/Magadan': 'RU',
  'Asia/Sakhalin': 'RU',
  'Asia/Srednekolymsk': 'RU',
  'Asia/Kamchatka': 'RU',
  'Asia/Anadyr': 'RU',
  'Asia/Riyadh': 'YE',
  'Pacific/Guadalcanal': 'SB',
  'Africa/Khartoum': 'SD',
  'Asia/Singapore': 'MY',
  'America/Paramaribo': 'SR',
  'Africa/Juba': 'SS',
  'Africa/Sao_Tome': 'ST',
  'America/El_Salvador': 'SV',
  'Asia/Damascus': 'SY',
  'America/Grand_Turk': 'TC',
  'Africa/Ndjamena': 'TD',
  'Asia/Bangkok': 'TH',
  'Asia/Dushanbe': 'TJ',
  'Pacific/Fakaofo': 'TK',
  'Asia/Dili': 'TL',
  'Asia/Ashgabat': 'TM',
  'Africa/Tunis': 'TN',
  'Pacific/Tongatapu': 'TO',
  'Europe/Istanbul': 'TR',
  'Asia/Taipei': 'TW',
  'Europe/Kyiv': 'UA',
  'America/New_York': 'US',
  'America/Detroit': 'US',
  'America/Kentucky/Louisville': 'US',
  'America/Kentucky/Monticello': 'US',
  'America/Indiana/Indianapolis': 'US',
  'America/Indiana/Vincennes': 'US',
  'America/Indiana/Winamac': 'US',
  'America/Indiana/Marengo': 'US',
  'America/Indiana/Petersburg': 'US',
  'America/Indiana/Vevay': 'US',
  'America/Chicago': 'US',
  'America/Indiana/Tell_City': 'US',
  'America/Indiana/Knox': 'US',
  'America/Menominee': 'US',
  'America/North_Dakota/Center': 'US',
  'America/North_Dakota/New_Salem': 'US',
  'America/North_Dakota/Beulah': 'US',
  'America/Denver': 'US',
  'America/Boise': 'US',
  'America/Phoenix': 'US',
  'America/Los_Angeles': 'US',
  'America/Anchorage': 'US',
  'America/Juneau': 'US',
  'America/Sitka': 'US',
  'America/Metlakatla': 'US',
  'America/Yakutat': 'US',
  'America/Nome': 'US',
  'America/Adak': 'US',
  'Pacific/Honolulu': 'US',
  'America/Montevideo': 'UY',
  'Asia/Samarkand': 'UZ',
  'Asia/Tashkent': 'UZ',
  'America/Caracas': 'VE',
  'Asia/Ho_Chi_Minh': 'VN',
  'Pacific/Efate': 'VU',
  'Pacific/Apia': 'WS',
  'Africa/Johannesburg': 'ZA',
  'America/Antigua': 'AG',
  'America/Anguilla': 'AI',
  'Africa/Luanda': 'AO',
  'Antarctica/McMurdo': 'AQ',
  'Antarctica/DumontDUrville': 'AQ',
  'Antarctica/Syowa': 'AQ',
  'America/Aruba': 'AW',
  'Europe/Mariehamn': 'AX',
  'Europe/Sarajevo': 'BA',
  'Africa/Ouagadougou': 'BF',
  'Asia/Bahrain': 'BH',
  'Africa/Bujumbura': 'BI',
  'Africa/Porto-Novo': 'BJ',
  'America/St_Barthelemy': 'BL',
  'Asia/Brunei': 'BN',
  'America/Kralendijk': 'BQ',
  'America/Nassau': 'BS',
  'Africa/Gaborone': 'BW',
  'America/Blanc-Sablon': 'CA',
  'America/Atikokan': 'CA',
  'America/Creston': 'CA',
  'Indian/Cocos': 'CC',
  'Africa/Kinshasa': 'CD',
  'Africa/Lubumbashi': 'CD',
  'Africa/Bangui': 'CF',
  'Africa/Brazzaville': 'CG',
  'Africa/Douala': 'CM',
  'America/Curacao': 'CW',
  'Indian/Christmas': 'CX',
  'Europe/Busingen': 'DE',
  'Africa/Djibouti': 'DJ',
  'Europe/Copenhagen': 'DK',
  'America/Dominica': 'DM',
  'Africa/Asmara': 'ER',
  'Africa/Addis_Ababa': 'ET',
  'Pacific/Chuuk': 'FM',
  'Pacific/Pohnpei': 'FM',
  'Africa/Libreville': 'GA',
  'America/Grenada': 'GD',
  'Europe/Guernsey': 'GG',
  'Africa/Accra': 'GH',
  'Africa/Banjul': 'GM',
  'Africa/Conakry': 'GN',
  'America/Guadeloupe': 'GP',
  'Africa/Malabo': 'GQ',
  'Europe/Zagreb': 'HR',
  'Europe/Isle_of_Man': 'IM',
  'Atlantic/Reykjavik': 'IS',
  'Europe/Jersey': 'JE',
  'Asia/Phnom_Penh': 'KH',
  'Indian/Comoro': 'KM',
  'America/St_Kitts': 'KN',
  'Asia/Kuwait': 'KW',
  'America/Cayman': 'KY',
  'Asia/Vientiane': 'LA',
  'America/St_Lucia': 'LC',
  'Europe/Vaduz': 'LI',
  'Africa/Maseru': 'LS',
  'Europe/Luxembourg': 'LU',
  'Europe/Monaco': 'MC',
  'Europe/Podgorica': 'ME',
  'America/Marigot': 'MF',
  'Indian/Antananarivo': 'MG',
  'Pacific/Majuro': 'MH',
  'Europe/Skopje': 'MK',
  'Africa/Bamako': 'ML',
  'Pacific/Saipan': 'MP',
  'Africa/Nouakchott': 'MR',
  'America/Montserrat': 'MS',
  'Africa/Blantyre': 'MW',
  'Asia/Kuala_Lumpur': 'MY',
  'Africa/Niamey': 'NE',
  'Europe/Amsterdam': 'NL',
  'Europe/Oslo': 'NO',
  'Asia/Muscat': 'OM',
  'Indian/Reunion': 'RE',
  'Africa/Kigali': 'RW',
  'Indian/Mahe': 'SC',
  'Europe/Stockholm': 'SE',
  'Atlantic/St_Helena': 'SH',
  'Europe/Ljubljana': 'SI',
  'Arctic/Longyearbyen': 'SJ',
  'Europe/Bratislava': 'SK',
  'Africa/Freetown': 'SL',
  'Europe/San_Marino': 'SM',
  'Africa/Dakar': 'SN',
  'Africa/Mogadishu': 'SO',
  'America/Lower_Princes': 'SX',
  'Africa/Mbabane': 'SZ',
  'Indian/Kerguelen': 'TF',
  'Africa/Lome': 'TG',
  'America/Port_of_Spain': 'TT',
  'Pacific/Funafuti': 'TV',
  'Africa/Dar_es_Salaam': 'TZ',
  'Africa/Kampala': 'UG',
  'Pacific/Midway': 'UM',
  'Pacific/Wake': 'UM',
  'Europe/Vatican': 'VA',
  'America/St_Vincent': 'VC',
  'America/Tortola': 'VG',
  'America/St_Thomas': 'VI',
  'Pacific/Wallis': 'WF',
  'Asia/Aden': 'YE',
  'Indian/Mayotte': 'YT',
  'Africa/Lusaka': 'ZM',
  'Africa/Harare': 'ZW',
};
